import React, { forwardRef, PropsWithChildren } from 'react';
import styled from 'styled-components';

import { OverflowMenuContext } from './OverflowMenuContext';

export interface OverflowMenuPanelProps {
    acceptFocus?: boolean;
    className?: string;
    isWhite?: boolean;
    /**
     * Needed for items virtualization purposes. Will be passed to the menu container.
     */
    menuHeight?: number;
    wideButton?: boolean;
    withButton?: boolean;
}

const OverflowMenuPanel = forwardRef<HTMLDivElement, PropsWithChildren<OverflowMenuPanelProps>>((props, ref) => {
    const {
        acceptFocus = false,
        children,
        className,
        menuHeight,
        isWhite = false,
        withButton,
        wideButton= false
    } = props;

    return (
        <OverflowMenuContext.Provider value={{ acceptFocus, isWhite }}>
            <Root className={ className }
                withButton={ withButton }
                ref={ ref }
                data-scroll-area="0px 0px 0px 0px"
            >
                { withButton && <HideShadow isWhite={ isWhite }
                    wideButton={ wideButton }
                /> }

                <Menu withButton={ withButton }
                    $height={ menuHeight }
                >
                    { children }
                </Menu>
            </Root>
        </OverflowMenuContext.Provider>
    );
});

OverflowMenuPanel.displayName = 'OverflowMenuPanel';

export default OverflowMenuPanel;

const Root = styled.div<{ withButton?: boolean }>`
  border-radius: ${ ({ theme, withButton }) => (withButton ? `${ theme.radius.radius_5 } 0 ${ theme.radius.radius_5 } ${ theme.radius.radius_5 }` : theme.radius.radius_5) };
  box-shadow: ${ ({ theme }) => theme.shadow.shadow_2 };
  position: relative;
  z-index: 1000;
`;

const Menu = styled.div.attrs<{ $height?: number }>(({ $height }) => ({
    style: {
        height: `${ $height }px`
    }
}))<{ withButton?: boolean; $height?: number }>`
  border-radius: ${ ({ theme, withButton }) => (withButton ? `${ theme.radius.radius_5 } 0 ${ theme.radius.radius_5 } ${ theme.radius.radius_5 }` : theme.radius.radius_5) };
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  position: relative;
`;

const HideShadow = styled.div<{ isWhite: boolean; wideButton: boolean }>`
  ${ ({ isWhite, theme, wideButton }) => `
        background: ${ isWhite ? 'white' : theme.semanticColor.ui_01 };
        content: '';
        height: ${ theme.size.size_5 };
        position: absolute;
        width: ${ wideButton ? theme.size.size_50 : theme.size.size_40 };
        right: 0;
        top: -${ theme.size.size_5 };
    ` };
`;
